import { useQuery } from 'react-query';
import axios from 'axios';
import { InvoicesDto } from '../models/invoice';

// item 1480 (Chad: "all of our KPIs are off… Techwest was six figures and winning and now NTA
// is") — every index endpoint defaults to a 100-row page; the moment the tenant crossed 100
// invoices (09-24 16:34Z, the 101st invoice) the dashboard silently lost the OLDEST rows —
// TWINV16662 ($133,089.69) among them — and every invoice-based KPI drifted. Ask for the whole
// index explicitly; the API default is raised too, but this works against any API build.
export const INDEX_PAGE = 2000;

export const getInvoices = async (): Promise<InvoicesDto> => {
  const apiUrl = process.env.REACT_APP_BASIX_API || '';
  const { data } = await axios.get(`${apiUrl}Invoice`, { params: { pageSize: INDEX_PAGE } });
  return data;
};

const useInvoices = () => useQuery('invoices', getInvoices);

export default useInvoices;

// item 142 — archived invoices (the Archived bucket on the global invoices grid).
// Separate endpoint (the main index excludes archived); merged into the grid client-side.
export const useArchivedInvoices = () => useQuery('invoices-archived', async (): Promise<InvoicesDto> => {
  const apiUrl = process.env.REACT_APP_BASIX_API || '';
  const { data } = await axios.get(`${apiUrl}Invoice/Archived`, { params: { pageSize: INDEX_PAGE } });
  return data;
});
